/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EfsMelcoModelsPreview
 */
export interface EfsMelcoModelsPreview {
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsPreview
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsPreview
     */
    url?: string | null;
}

export function EfsMelcoModelsPreviewFromJSON(json: any): EfsMelcoModelsPreview {
    return EfsMelcoModelsPreviewFromJSONTyped(json, false);
}

export function EfsMelcoModelsPreviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoModelsPreview {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function EfsMelcoModelsPreviewToJSON(value?: EfsMelcoModelsPreview | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'url': value.url,
    };
}


